import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { InfoIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface Props {
  label: string;
  labelClassName?: string;
  hasBackground?: boolean;
  backgroundColor?: string;
  content: any;
  isLink?: boolean;
  linkText?: string;
  contentCSS?: string;
  className?: string;
  tooltip?: string;
}

function TextInfoGroupAlt(props: Props) {
  const { label, labelClassName, hasBackground, backgroundColor = "slate", content, isLink, linkText, contentCSS, className, tooltip } = props;
  return (
    <div className={cn("gap-y-1", className, hasBackground && `bg-${backgroundColor}-50 p-2 rounded-md`)}>
      <p className={cn("flex items-start text-xs text-gray-400 dark:text-gray-300", labelClassName)}>
        {label}
        {
          tooltip &&
          <Tooltip>
            <TooltipTrigger asChild><InfoIcon className="inline h-4"/></TooltipTrigger>
            <TooltipContent>
              <p className="max-w-[320px]">{tooltip}</p>
            </TooltipContent>
          </Tooltip>
        }
      </p>
      {
        isLink ?
          <a className={cn("text-sm text-blue-400", contentCSS)}
            href={content}
            target="_blank"
            rel="noreferrer"
          >
            {linkText ?? content}
          </a>:
          <p className={cn("text-sm font-gray-700 dark:text-white", contentCSS)}>
            {content}
          </p>
      }
    </div>
  );
}

export default TextInfoGroupAlt;
